import type {
  AdminDeleteUserRequest,
  AdminUpdateUserRequest,
  AdminUserResponse,
  AuthStatusResponse,
  CreatePasteRequest,
  CreatePasteResponse,
  PasteResponse,
} from '../shared/api-types';
import { apiFetch } from './http';

export function getAuthStatus(): Promise<AuthStatusResponse> {
  return apiFetch<AuthStatusResponse>('/api/auth/status');
}

export function createPaste(payload: CreatePasteRequest): Promise<CreatePasteResponse> {
  return apiFetch<CreatePasteResponse>('/api/pastes', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export function getPaste(id: string): Promise<PasteResponse> {
  return apiFetch<PasteResponse>(`/api/pastes/${encodeURIComponent(id)}`);
}

export function consumePaste(id: string): Promise<PasteResponse> {
  return apiFetch<PasteResponse>(`/api/pastes/${encodeURIComponent(id)}/consume`, {
    method: 'POST',
    body: '{}',
  });
}

export function getAdminUsers(): Promise<AdminUserResponse> {
  return apiFetch<AdminUserResponse>('/api/admin/users');
}

export function setUserDisabled(userId: string, disabled: boolean): Promise<{ ok: true }> {
  return updateAdminUser(userId, { disabled });
}

export function updateAdminUser(userId: string, payload: AdminUpdateUserRequest): Promise<{ ok: true }> {
  return apiFetch<{ ok: true }>(`/api/admin/users/${encodeURIComponent(userId)}`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
}

export function forceLogoutAdminUser(userId: string): Promise<{ ok: true }> {
  return apiFetch<{ ok: true }>(`/api/admin/users/${encodeURIComponent(userId)}/logout`, {
    method: 'POST',
  });
}

export function deleteAdminUser(userId: string, payload: AdminDeleteUserRequest): Promise<{ ok: true }> {
  return apiFetch<{ ok: true }>(`/api/admin/users/${encodeURIComponent(userId)}`, {
    method: 'DELETE',
    body: JSON.stringify(payload),
  });
}
